import angular from 'angular';
import onboardingAdditionalParties from './onboardingAdditionalParties';

export default angular
  .module('components.onboardingAdditionalParties', [])
  .component('onboardingAdditionalParties', onboardingAdditionalParties).name;
